import { useSelector } from 'react-redux';
import DoormanNav from '../Navs/DoormanNav';
import ConciergeNav from '../Navs/ConciergeNav';
import CustomerNav from '../Navs/CustomerNav';

const NavSelector = ({ history, isDisabled, id }) => {
  const { user } = useSelector((state) => state.associates);
  const { roles = [] } = user || {}; 

  const roleToComponentNav = {
    //doorman: <DoormanNav isDisabled={isDisabled} id={id}/>,
    customer: <CustomerNav history={history} />, 
    default: <ConciergeNav history={history} />,
};

  for (const role of roles) {
    if (roleToComponentNav[role]) {
      return roleToComponentNav[role];
    }
  }

  return roleToComponentNav.default;
};

export default NavSelector;
